import { TableRow as MuiTableRow } from "@mui/material";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { JSX } from "react";

import { DragAndDropCarrier } from "./types";
import TableCell from "./tableCell";

function SortableRow({
  column,
  carrier,
  index,
  showIndex,
}: DragAndDropCarrier): JSX.Element {
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: carrier.id,
    data: { column, carrier, index, showIndex },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <MuiTableRow
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      sx={{
        cursor: "move",
        borderBottom: 1,
        borderColor: "grey.300",
        bgcolor: "common.white",
        opacity: isDragging ? 0 : 1,
        ...style,
      }}
    >
      {showIndex && <TableCell>{index + 1}</TableCell>}
      <TableCell>{carrier.name}</TableCell>
    </MuiTableRow>
  );
}

export default SortableRow;
